export default "__VITE_ASSET__052dc0f7__"